import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useState } from "react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  DropdownMenuLabel,
} from "@/components/ui/dropdown-menu/dropdown-menu";
import { useAuth, useAuthContext } from "@/lib/use-auth";

import { useJBLogoutModal } from "./_comps/just-before-logout-modal/use-jb-logout-modal";
import { useMutation } from "@tanstack/react-query";
import { createAdminActivity } from "@/config/mutation/super-admin";

export const UserMenu = () => {
  // const key = Cookies.get("key") as string;
  const userRole = localStorage.getItem("userRole") as string;
  const { data } = useAuth();

  const navigate = useNavigate();
  const { setisAuth, removeUser } = useAuthContext();
  const [open, setOpen] = useState(false);

  const { onOpenChange } = useJBLogoutModal();

  const { mutateAsync } = useMutation({
    mutationFn: createAdminActivity(),
  });

  const handleLogout = async () => {
    if (userRole === "admin") {
      await mutateAsync({
        admin: data?.user?._id as string,
        mode: "LOGOUT",
      });
      Cookies.remove("key");
      localStorage.clear();
      setisAuth(false);
      removeUser();
      toast.success("Log out Success!");
      navigate("/", {
        replace: true,
      });

      return;
    }

    if (userRole === "superadmin") {
      Cookies.remove("key");
      localStorage.clear();
      setisAuth(false);
      removeUser();
      toast.success("Log out Success!");
      navigate("/", {
        replace: true,
      });

      return;
    }

    onOpenChange(true);
    setOpen(false);

    // const empid = data?.user?._id as string;
    // await checkoutForEmployee(empid, () => {
    //   Cookies.remove("key");
    //   localStorage.clear();
    //   setisAuth(false);
    //   removeUser();
    //   toast.success("Log out Success!");
    //   navigate("/", {
    //     replace: true,
    //   });
    // });
  };

  return (
    <div>
      <DropdownMenu open={open} onOpenChange={setOpen}>
        <DropdownMenuTrigger className="flex items-center gap-2">
          {data?.user?.photo ? (
            <div className="relative w-8 h-8 rounded-full overflow-hidden shrink-0">
              <img src={data?.user?.photo} alt="Profile picture" />
            </div>
          ) : (
            <span className="w-8 h-8 shrink-0 rounded-full flex items-center justify-center bg-ring/10">
              {data?.user?.name?.charAt(0)}
            </span>
          )}
          {/* Account name inline: a lone initial can't tell "Admin 1" from "Admin 001",
              which is how a signed-in admin ended up on the wrong account unnoticed. */}
          <span className="hidden sm:block max-w-[160px] truncate text-sm font-medium">
            {data?.user?.name}
          </span>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="mr-32 max-w-60 w-full">
          <DropdownMenuLabel>{data?.user?.name}</DropdownMenuLabel>
          <DropdownMenuLabel className="text-xs">
            {data?.user?.email}
          </DropdownMenuLabel>
          <DropdownMenuSeparator className="bg-accent" />
          {userRole === "employee" && (
            <DropdownMenuItem
              className="hover:cursor-pointer hidden sm:block"
              onMouseDown={() => navigate("/employee/profile")}
            >
              Profile
            </DropdownMenuItem>
          )}
          <DropdownMenuItem
            className="hover:cursor-pointer"
            onMouseDown={handleLogout}
          >
            Log out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
